export const actOrgans = [
    'general_assembly',
    'administration_council',
    'surveillance_council',
];
export const actSessionTypes = ['ordinary', 'extraordinary', 'informative'];
const date = /^\d{4}-\d{2}-\d{2}$/;
export const isActContract = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const a = value;
    return (typeof a.id === 'string' &&
        typeof a.number === 'string' &&
        actOrgans.includes(a.organ) &&
        Number.isInteger(a.sequence) &&
        date.test(a.date ?? '') &&
        actSessionTypes.includes(a.sessionType) &&
        typeof a.subject === 'string' &&
        typeof a.resolutions === 'string' &&
        date.test(a.effectiveFrom ?? '') &&
        (a.effectiveTo === null || date.test(a.effectiveTo ?? '')) &&
        (a.documentStatus === 'pending' || a.documentStatus === 'approved') &&
        (a.document === null ||
            (typeof a.document === 'object' &&
                a.document !== null &&
                a.document.mimeType === 'application/pdf' &&
                typeof a.document.fileName === 'string' &&
                typeof a.document.sha256 === 'string' &&
                Number.isInteger(a.document.sizeBytes))) &&
        typeof a.createdAt === 'string' &&
        typeof a.registeredBy === 'object' &&
        a.registeredBy !== null &&
        typeof a.registeredBy.displayName === 'string' &&
        Array.isArray(a.registeredBy.roles) &&
        a.registeredBy.roles.every((role) => typeof role === 'string') &&
        Number.isInteger(a.version) &&
        (a.deletedAt === null || typeof a.deletedAt === 'string'));
};
export const isActsListResponse = (value) => typeof value === 'object' &&
    value !== null &&
    Array.isArray(value.items) &&
    value.items.every(isActContract);
export const isActDetailResponse = (value) => typeof value === 'object' && value !== null && isActContract(value.act);
